import React from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment';

const FlightsTooltipData = ({ flight }) => {
  const theme = useTheme();

  const citySubTitleSx = {
    fontFamily: 'Open Sans',
    fontSize: '12px',
    fontWeight: 300,
    textTransform: 'capitalize',
    lineHeight: 0.5,
  };

  const citySubTitleDateSx = {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontWeight: 300,
    whiteSpace: 'nowrap',
  };

  return (
    <React.Fragment>
      <Grid item xs={5} sx={{ padding: '0 0 10px 8px', textAlign: 'center' }}>
        <Typography component="div" sx={{ textAlign: 'center' }}>
          <Typography
            component="div"
            sx={{
              fontFamily: 'Open Sans',
              fontWeight: 700,
              fontSize: 20,
              color: theme.tertiary || '#000',
              mb: 0.5,
            }}
          >
            {flight?.origen}
          </Typography>
          <Typography component="div" sx={{ ...citySubTitleSx, mb: 0.5 }}>
            {flight?.origin_city?.toLowerCase()}
          </Typography>
          <Typography component="div" sx={{ ...citySubTitleDateSx }}>
            {moment(flight?.horaSalida)?.format('DD/MM/YY HH:mm')}
          </Typography>
        </Typography>
      </Grid>

      <Grid item xs={1} sx={{ alignSelf: 'center' }}>
        <ArrowForwardIcon
          sx={{
            fontSize: 30,
            color: theme.primary || '#000',
            pb: 0,
          }}
        />
      </Grid>

      <Grid item xs={5} sx={{ padding: '0 0 10px 8px', textAlign: 'center' }}>
        <Typography component="div" sx={{ textAlign: 'center' }}>
          <Typography
            component="div"
            sx={{
              fontFamily: 'Open Sans',
              fontWeight: 700,
              fontSize: 20,
              color: theme.tertiary || '#000',
              mb: 0.5,
            }}
          >
            {flight?.destino}
          </Typography>
          <Typography component="div" sx={{ ...citySubTitleSx, mb: 0.5 }}>
            {flight?.destination_city?.toLowerCase()}
          </Typography>
          <Typography component="div" sx={{ ...citySubTitleDateSx }}>
            {moment(flight?.horaLlegada)?.format('DD/MM/YY HH:mm')}
          </Typography>
        </Typography>
      </Grid>
    </React.Fragment>
  );
};

export default FlightsTooltipData;
